import React, { useState } from 'react';
import {
  Button,
  Container,
  FormControl,
  Box,
  Modal,
  Tooltip,
  Paper,
  TextField,
  Typography
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const AddModeOfDelivery = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [modeName, setModeName] = useState('');
  const [remark, setRemark] = useState('');
  const navigate = useNavigate();

  const handleSave = (e) => {
    e.preventDefault();
    if (modeName && remark) {
      setShowSuccessModal(true);
    } else {
      alert('Please fill all fields');
    }
  };

  const handleCancel = () => {
    setModeName('');
    setRemark('');
  };

  return (
    <Container>
      <Box
        sx={{
          backgroundColor: 'rgba(2, 78, 101, 1)',
          padding: '12px 16px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
          margin: '0 auto',
          width: "100%",
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
          Add Mode of Delivery
        </Typography>
      </Box>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6, backgroundColor: '#f8fdfeff' }}>
        <div>
          <TextField
            label="Mode Name"
            variant="outlined"
            fullWidth
            value={modeName}
            onChange={(e) => setModeName(e.target.value)}
            sx={{ mb: 3 }}
          />
          <TextField
            label="Remark"
            variant="outlined"
            fullWidth
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Tooltip title={!modeName ? "Enter Mode Name" : !remark ? "Enter Remark" : ""} arrow>
            <span>
              <Button
                variant="contained"
                onClick={handleSave}
                sx={{
                  mr: 2,
                  backgroundColor: '#127498ff',
                  '&:hover': { backgroundColor: '#116280ff' }
                }}
                disabled={!modeName || !remark}
              >
                SAVE
              </Button>
            </span>
          </Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
          >
            RESET
          </Button>
        </div>
      </Paper>
      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Mode of Delivery Added ✅
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              Mode of Delivery Added Successfully
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default AddModeOfDelivery;
